import { PrimaryBigButton } from 'components/ReusableComponents/Button/BigButtons'
import InfoIcon from 'components/ReusableComponents/Icons/Info'
import Dropdown from 'components/ReusableComponents/ManageHotel/Dropdown'
import EinHint from 'components/TaxInfoDialog/EinHint'
import EinInput from 'components/TaxInfoDialog/EinInput'
import { Controller, useForm } from 'react-hook-form'
import { useToasts } from 'react-toast-notifications'
import contractApi from 'services/api/contracts'
import canadianProvinces from 'static/addresses/canadianProvinces'

import styles from './CanadaForm.module.scss'

/**
 *
 * @returns {React.JSX.Element}
 */
const CanadaForm = ({ onStepComplete }) => {
  const { addToast } = useToasts()
  const { watch, control, register, setValue, handleSubmit } = useForm()

  const submit = handleSubmit(data => {
    contractApi.lagelInfo
      .add({
        DoingBusinessAsName: data.name,
        LegalBusinessName: data.businessName,
        TaxId: data.ein
      })
      .then(() => {
        addToast('Form submitted successfully', {
          appearance: 'success',
          autoDismiss: true
        })
      })
      .catch(() => {
        addToast('Something went wrong', {
          appearance: 'error',
          autoDismiss: true
        })
      })

    onStepComplete()
  })

  return (
    <div className={styles.container}>
      <div className={styles.left}>
        <p className={styles.title}>Legal information</p>
        <p className={styles.description}>
          This information is required due to mobile carrier campaign registry
          requirements.
        </p>

        <div className={styles.divider} />

        <div className={styles.titleRow}>
          <InfoIcon className={styles.icon} />
          <p className={styles.text}>Canadian Corporation Number</p>
        </div>

        <p className={styles.subtitle}>
          This is your unique eight-digit number assigned by Corporations Canada to a
          corporation at the time of registration. Note: this number is different from a
          Business Number (BN) which is issued by the Canada Revenue Agency (CRA) for tax
          purposes.
        </p>

        <a
          href="https://beta.canadasbusinessregistries.ca/search"
          target="_blank"
          rel="noreferrer"
        >
          Find your business in Canada Business Registries{' '}
        </a>
        <br />
        {watch('province') === 'ON' && (
          <a
            href="https://www.appmybizaccount.gov.on.ca/onbis/master/viewInstance/view.pub?id=3abd3bce3cc0ad2aa8a02e89f13ba26956db547a6d015cc8&_timestamp=3234734835852443"
            target="_blank"
            rel="noreferrer"
          >
            Find your Ontario Corporation Number
          </a>
        )}
      </div>

      <form onSubmit={submit} className={styles.right}>
        <span className={styles.label}>Registered province</span>
        <Controller
          name="province"
          control={control}
          render={({ field }) => <Dropdown options={canadianProvinces} {...field} />}
        />

        <span className={styles.label}>Name (as shown on income tax return)</span>
        <input placeholder="Type something" {...register('name')} />
        <span className={styles.label}>Business name</span>
        <input placeholder="Type something" {...register('businessName')} />
        <span className={styles.label}>Hotel support email</span>
        <input placeholder="Type something" {...register('supportEmail')} />
        <span className={styles.label}>Provincial Corporation Number</span>
        <input placeholder="Type something" {...register('corporationNumber')} />

        <div className={styles.einInput}>
          <EinInput
            setEin={val => setValue('ein', val)}
            ein={watch('ein')}
            province={watch('province')}
            isCanadian
          />
        </div>

        <EinHint province={watch('province')} isCanadian />
      </form>

      <div className={styles.bottomBar}>
        <div className={styles.bottomBarContainer}>
          <div className={styles.bottomBarButtonsHolder}>
            <PrimaryBigButton onClick={submit}>Complete Setup</PrimaryBigButton>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CanadaForm
